var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal--buttons"},[_c('base-button',{attrs:{"backgroundColor":"white","text":"Avbryt"},on:{"click":function($event){return _vm.closeModal()}}}),_c('base-button',{attrs:{"backgroundColor":"bb-primary","text":_vm.$t('saveAndPublish')},on:{"click":function($event){return _vm.saveAndPublish()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }